const EMPTY_ROW_NAVIGATION_STATE = Object.freeze({
  canScrollLeft: false,
  canScrollRight: false,
});

const isValidBounds = (bounds) =>
  Number.isFinite(bounds?.left) &&
  Number.isFinite(bounds?.right) &&
  bounds.right > bounds.left;

export const getRowNavigationState = ({
  containerBounds,
  playerBounds,
  tolerance = 1,
} = {}) => {
  if (!isValidBounds(containerBounds) || !Array.isArray(playerBounds) || playerBounds.length <= 1) {
    return EMPTY_ROW_NAVIGATION_STATE;
  }

  const visiblePlayerBounds = playerBounds.filter(isValidBounds);

  return {
    canScrollLeft: visiblePlayerBounds.some(({ left }) => left < containerBounds.left - tolerance),
    canScrollRight: visiblePlayerBounds.some(({ right }) => right > containerBounds.right + tolerance),
  };
};

export const getRowNavigationInsets = ({
  containerBounds,
  viewportWidth,
  inset = 10,
} = {}) => {
  if (!isValidBounds(containerBounds) || !Number.isFinite(viewportWidth) || viewportWidth <= 0) {
    return { left: inset, right: inset };
  }

  return {
    left: Math.max(inset, inset - containerBounds.left),
    right: Math.max(inset, containerBounds.right - viewportWidth + inset),
  };
};
